/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateAdminDto = {
  /**
   * 비밀번호 변경
   */
  password?: string;
  /**
   * 이름
   */
  name?: string;
  /**
   * 역할
   */
  role?: UpdateAdminDto.role;
};
export namespace UpdateAdminDto {
  /**
   * 역할
   */
  export enum role {
    SUPER = "SUPER",
    STAFF = "STAFF",
  }
}
